/**
 * Tab Component
 *
 * @file tab.js
 */

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const init = () => {
    defaultTab();
  };

  return {
    init,
  };
})();

export default tabs;
